import { create_chat_logs } from "./chatUtility";

function createTimeStamp() {
  const d = new Date();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const year = d.getFullYear();
  const hours = d.getHours();
  var minutes = d.getMinutes();
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  const timeStamp =
    year + "-" + month + "-" + day + " " + hours + ":" + minutes;
  return timeStamp;
}

function createFive9WebSocket() {
  const wsAddress = process.env.REACT_APP_FIVE9_WEBSOCKET_NGROK;
  console.log(process.env.REACT_APP_FIVE9_WEBSOCKET);
  const wsClient = new WebSocket(wsAddress);

  wsClient.onopen = (event) => {
    console.log("five9 opened");
    //setWs(wsClient);
  };

  return wsClient;
}

function sendFive9ChatMessage(ws, txt, tId, fId, sId, aURL, eId) {
  const data = {
    text: txt,
    tokenId: tId,
    farmId: fId,
    sessionId: sId,
    apiURL: aURL,
    extId: eId,
  };

  console.log("Session Storage is ", sessionStorage.getItem("tokenId"));

  ws.send(
    JSON.stringify({
      action: "Five9SendMessage",
      data,
    })
  );
}

function WebSocketMessageHandler(event, ws, appendMsg, messages) {
  var json = JSON.parse(event.data);

  if (json.message == "Five9AgentAccepted") {
    const fetchData = async () => {
      const message_history = await create_chat_logs(messages);
      console.log("message_history: ", message_history);

      var tId = sessionStorage.getItem("tokenId");
      var fId = sessionStorage.getItem("farmId");
      var aURL = sessionStorage.getItem("apiURL");
      var sId = sessionStorage.getItem("sessionId");
      var eId = sessionStorage.getItem("extId");

      sendFive9ChatMessage(ws, message_history, tId, fId, sId, aURL, eId);

      //send_five9message(message_history);
    };
    fetchData().catch(console.error);

    return appendMsg({
      type: "divider",
      content: {
        text: "Five9AgentAccepted",
        time: createTimeStamp(),
        agentName: json.agentName,
      },
      position: "center",
    });
  } else if (json.message == "NewFive9AgentJoined") {
    return appendMsg({
      type: "divider",
      content: {
        text: "Five9AgentAccepted",
        time: createTimeStamp(),
        agentName: json.agentName,
      },
      position: "center",
    });
  } else if (json.message == "Five9AgentLeft") {
    return appendMsg({
      type: "divider",
      content: {
        text: "Five9AgentLeft",
        time: createTimeStamp(),
        agentName: json.agentName,
      },
      position: "center",
    });
  } else if (json.message == "Ended") {
    return appendMsg({
      type: "text",
      content: { text: "Five9 agent ended the chat" },
      position: "left",
      user: {
        avatar: (document.getElementById("favIcon").href = "./img/genesys.svg"),
      },
    });
  } else if (json.message == "Five9AgentTransfer") {
    return appendMsg({
      type: "divider",
      content: { text: "Five9AgentTransfer", time: createTimeStamp() },
      position: "center",
    });
  } else if (json.message == "Five9GroupTransfer") {
    return appendMsg({
      type: "divider",
      content: { text: "Five9GroupTransfer", time: createTimeStamp() },
      position: "center",
    });
  } else if (json.message == "ChatSessionData") {
    var data = json.data;

    sessionStorage.setItem("tokenId", data.tokenId);
    sessionStorage.setItem("farmId", data.farmId);
    sessionStorage.setItem("apiURL", data.apiURL);
    sessionStorage.setItem("sessionId", data.sessionId);
    sessionStorage.setItem("extId", json.extId);
  } else {
    if ("msgId" in json) {
      const data = {
        tokenId: sessionStorage.getItem("tokenId"),
        sessionId: sessionStorage.getItem("sessionId"),
        farmId: sessionStorage.getItem("farmId"),
        apiURL: sessionStorage.getItem("apiURL"),
        msgId: json.msgId,
      };

      ws.send(
        JSON.stringify({
          action: "Five9SendACK",
          data,
        })
      );
    }

    return appendMsg({
      type: "text",
      content: { text: json.message },
      position: "left",
      user: {
        avatar: (document.getElementById("favIcon").href = "./img/genesys.svg"),
      },
    });
  }
}

export { createFive9WebSocket, sendFive9ChatMessage, WebSocketMessageHandler };
